export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="py-16 bg-gradient-to-br from-teal-600 to-teal-700">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/2c21611a-d5e5-4281-8075-cbdd4ec1b924.png" 
                alt="STRADE SRL Logo" 
                className="h-10 w-auto"
              />
              <span className="text-2xl font-bold text-white">STRADE SRL</span>
            </div>
            <p className="text-teal-100 text-sm leading-relaxed">
              Securing Your Digital Freedom
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Product</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('features')}
                  className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  VPN Features
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Download
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('features')}
                  className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Security
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Support
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Contact
                </button>
              </li>
              <li>
                <a href="#" className="text-teal-100 hover:text-white transition-colors text-sm">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-teal-100 hover:text-white transition-colors text-sm">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Stay Updated</h3>
            <p className="text-teal-100 text-sm mb-4">
              Subscribe to our newsletter
            </p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 px-4 py-2 rounded-full bg-white/10 border border-white/20 text-white placeholder-teal-200 focus:outline-none focus:ring-2 focus:ring-white/50 text-sm"
              />
              <button className="w-10 h-10 flex items-center justify-center bg-white text-teal-600 rounded-full hover:bg-teal-50 transition-colors">
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-teal-500/30">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-teal-100 text-sm">
              © 2025 STRADE SRL. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-teal-100 hover:text-white transition-colors text-sm"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
